import { useTranslation } from 'react-i18next';

const customerKeyToDisplayName = (key: string | null) => {
    let parsed_key = '';
    const { t } = useTranslation();

    if (key === 'email') parsed_key = t('email');
    else if (key === 'name') parsed_key = t('name');
    else if (key === 'phone_number') parsed_key = t('phone_number');
    else if (key === 'city') parsed_key = t('city');
    else if (key === 'care_of') parsed_key = t('care_of');
    else if (key === 'street_address') parsed_key = t('street_address');
    else if (key === 'postal_code') parsed_key = t('postal_code');
    else {
        return '';
    }

    return parsed_key;
};

export default customerKeyToDisplayName;
